import type { ReactNode } from 'react';
import { useQuickSubmit } from '@gonfalon/dom/useQuickSubmit';
import type { TextFieldProps } from '@launchpad-ui/components';
import { Text, TextArea, TextField } from '@launchpad-ui/components';

type CommentAreaProps = TextFieldProps & {
  placeholder?: string;
  rows?: number;
  required?: boolean;
  disabled?: boolean;
  description?: ReactNode;
};

export const CommentArea = ({
  required,
  placeholder = '',
  rows = 4,
  disabled,
  description,
  ...additionalProps
}: CommentAreaProps) => {
  const quicksubmit = useQuickSubmit();

  return (
    <TextField
      id={COMMENT_AREA_ID}
      name={COMMENT_AREA_ID}
      isRequired={required}
      isDisabled={disabled}
      {...additionalProps}
      {...quicksubmit.props}
    >
      {description ? <Text slot="description">{description}</Text> : null}
      <TextArea placeholder={placeholder} rows={rows} />
    </TextField>
  );
};

export const COMMENT_AREA_ID = 'comment';
